import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({ printMode: false, togglePrintMode: () => {} });

export function ThemeProvider({ children }) {
  const [printMode, setPrintMode] = useState(() => {
    return localStorage.getItem('resovia_printMode') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('resovia_printMode', printMode);
    if (printMode) {
      document.documentElement.classList.add('print-mode');
    } else {
      document.documentElement.classList.remove('print-mode');
    }
  }, [printMode]);

  return (
    <ThemeContext.Provider value={{ printMode, togglePrintMode: () => setPrintMode(p => !p) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
